import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-42e73663")

_pushScopeId("data-v-42e73663")
const _hoisted_1 = /*#__PURE__*/_createVNode("h2", { class: "title" }, "Введите код подтверждения", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "form-text" }, "Для продолжения, проверьте свою почту и введите код подтверждения", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Подтвердить код ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_password = _resolveComponent("icon-password")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("form", {
    class: "ConfirmationForm",
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitConfirm && _ctx.emitConfirm(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_s_input, {
      placeholder: "Код подтверждения",
      class: "code",
      value: _ctx.confirmationState.code,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmationState.code = $event))
    }, {
      icon: _withId(() => [
        _createVNode(_component_icon_password)
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_s_input, {
      placeholder: "Новый пароль",
      class: "password",
      value: _ctx.confirmationState.newPassword,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmationState.newPassword = $event))
    }, {
      icon: _withId(() => [
        _createVNode(_component_icon_password)
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_s_button, {
      class: "green",
      loading: _ctx.loading
    }, {
      default: _withId(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode("span", {
      class: "back-text",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.emitBack && _ctx.emitBack(...args)))
    }, " Назад ")
  ], 32))
})